import { create } from "zustand";

import type { SheetContentType } from "@/types";

interface SheetState {
  isOpen: boolean;
  type: SheetContentType;
}

interface SheetActions {
  setType: (type: SheetContentType) => void;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export type SheetStore = SheetState & SheetActions;

const initialDefaultState: SheetState = {
  isOpen: false,
  type: "menu",
};

export const useSheetStore = create<SheetStore>()((set) => ({
  ...initialDefaultState,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  setType: (type) => set({ type }),
}));
